export default "__VITE_ASSET__CvlnEwh3__"